<template>
  <div class="app">
    <div class="mos" v-if="isPhone==false">
      <div class="section" id="section0">
        <div class="container section0">
          <div class="play" v-if="section0Play == false" @click="changeSection0Play()">
            <img alt="xxx" src="../assets/imgs/1002.png" style="width: 100%;" />
          </div>
          <div v-if="section0Play == true">
            <video class="video" autoplay="autoplay" loop="loop">
              <source src="../static/video/101.mp4" type="video/mp4" />
            </video>
            <div class="close"></div>
          </div>
        </div>
      </div>

      <div class="section" id="section1">
        <div class="container section1">
          <video class="left-video" muted autoplay="autoplay" loop="loop" controls="controls">
            <source src="../static/video/201.mp4" type="video/mp4" />
          </video>
          <div class="title-contain">
            <div class="title">
              <img alt="xxx" src="../assets/imgs/202.png" style="width: 100%;" />
            </div>
            <div class="content pub-text">
              基于上汽大众云服务平台
              <br />以SVW ID为中心
              <br />集成互联网优质资源
              <br />引入丰富多彩的在线服务
              <br />依托万物互联技术
              <br />全面打造人-车-生活的互联新体验
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>

      <div class="section" id="section2">
        <div class="container section2">
          <div class="content">
            <div class="title-box">
              <img alt="xxx" src="../assets/imgs/3001.png" style="width: 100%;" />
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/3002.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">在线语音识别</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">通过降噪、识别和自然语义理解将语音转换成文字，精确理解用户意图。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/3003.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">多轮交互</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">结合上下文场景理解，同用户进行持续多轮的对话交互。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/3004.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">语音控制</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">以语音作为交互入口，控制车辆，联动服务，真正解放车主双手。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/3005.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">自定义唤醒词</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">用户可以使用默认唤醒词“你好，大众”，也可以自己个性化定制唤醒词来唤起语音对话。</div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="section3">
        <div class="container section3">
          <div class="content">
            <div class="title-box">
              <img alt="xxx" src="../assets/imgs/4001.png" style="width: 100%;" />
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/4002.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">实时交通、交通看板及道路限行信息</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">以实时在线交通数据为基础，为用户提供精准的实时路况信息、城市主干道路拥堵状况以及城市限行信息。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/4003.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">在线地图更新</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">根据用户出行习惯和当前城市，为用户静默更新地图，时刻保持全新地图数据，告别手动下载，无需等待更省时。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/4004.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">智慧预测导航</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">依托大数据分析技术，根据用户的每日行驶数据，结合交通信息，给用户提供智能的出行建议。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/4005.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">兴趣点搜索及发送到车</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">用户可以使用上汽大众超级App或微信小程序搜索兴趣点并一键发送到车，方便用户在上车之前进行出行规划。</div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="section4">
        <div class="container section4">
          <div class="content">
            <div class="title-box">
              <img alt="xxx" src="../assets/imgs/5001.png" style="width: 100%;" />
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/5002.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">在线音乐</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">接入酷我音乐，为车主提供个性化、高品质、车内外权益（VIP账号）互通的极致音乐体验。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/5003.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">在线电台</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">接入喜马拉雅FM，为车主提供多元化、高品质、车内外权益（VIP账号）互通的精品电台内容。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/5004.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">安卓应用商店</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">
                为用户提供车机端安卓App，丰富上汽大众移动互联生态，<br />提升用户用车体验。
              </div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/5005.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">车载Wi-Fi热点</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">支持同时连接多台外置设备，方便同行的家人和朋友轻松使用无线网络。</div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="section5">
        <div class="container section5">
          <div class="content-section-title-box">
            <img alt="xxx" src="../assets/imgs/6001.png" style="width: 100%;" />
          </div>
          <div class="content">
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/6002.png" style="width: 100%;" />
                </div>
                <div class="icon2">
                  <img alt="xxx" src="../assets/imgs/6003.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">组队出行及“腾讯我的车”</div>
                <div style="clear: both;"></div>
              </div>
              <div
                class="text-line pub-text"
              >多人微信互联，组队出行，一键选择集结点，车机屏与微信端共同导航到集结位置，与组队成员位置实时共享，精彩旅途不断线。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/6004.png" style="width: 100%;" />
                </div>
                <div class="icon2">
                  <img alt="xxx" src="../assets/imgs/6005.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">智慧停车与车内在线支付</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">与多家智慧停车场合作，可手机查看停车状态并提前交费，支持免密扣款支付，方便快捷。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/6006.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">维保预约服务</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">智能提醒用户进行车辆保养，并提供手机在线预约服务，一键预约，方便快捷。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/6007.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">智能家居</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">与京东平台深度合作，同级产品中，率先搭载智能家居，让车与家合二为一，从此，出发和回家也将会变得更有温度。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" id="section6">
        <div class="container section6">
          <div class="content-section-title-box">
            <img alt="xxx" src="../assets/imgs/7001.png" style="width: 100%;" />
          </div>
          <div class="content">
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/7002.png" style="width: 100%;" />
                </div>
                <div class="icon2">
                  <img alt="xxx" src="../assets/imgs/7003.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">远程控车</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">手机远程控制汽车解锁闭锁，忘记锁车也可以一键解决；远程闪灯鸣笛，迅速锁定车辆位置，停车场找车不再难。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/7004.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">在线寻车</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">用户可以通过APP一键寻车，并查看与车辆距离，自动规划寻车路线。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/7005.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">车辆管理</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">电子围栏实时掌握车辆行驶范围，结合超速报警系统，即便车辆不在身边，也能洞悉车辆速度及位置，让爱车尽在掌握。</div>
            </div>
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/7006.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">车辆健康报告</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">随时关注您的行驶数据及车辆健康状况，助您及时排除安全隐患。</div>
            </div>
          </div>
          <div class="content content2-section6">
            <div class="box">
              <div class="title-line">
                <div class="icon">
                  <img alt="xxx" src="../assets/imgs/7007.png" style="width: 100%;" />
                </div>
                <div class="title pub-title2">远程查看车辆状态</div>
                <div style="clear: both;"></div>
              </div>
              <div class="text-line pub-text">远程查看车辆总里程、车门车窗是否关闭，方便车主随时观察爱车状态。</div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="section7">
        <div class="container section7">
          <div class="content-box1">
            <div class="title-line">
              <div class="title">
                <img alt="xxx" src="../assets/imgs/802.png" style="width: 100%;" />
              </div>
              <div class="text">整合优质资源，互联生活无缝体验</div>
            </div>
          </div>
          <div class="content-box2" id="content-box2">
            <div class="img"></div>
          </div>
          <div class="content-box3" id="content-box3">
            <div class="img"></div>
          </div>
          <div class="content-box4" id="content-box4">
            <div class="img"></div>
          </div>
          <div class="content-box5" id="content-box5">
            <div class="img"></div>
          </div>
          <div class="content-box6" id="content-box6">
            <div class="img"></div>
          </div>
          <div class="content-box7" id="content-box7">
            <div class="img"></div>
          </div>

          <div class="content-box8" id="content-box8">
            <div class="img"></div>
          </div>
          <div class="content-box9" id="content-box9">
            <div class="img"></div>
          </div>
          <div class="content-box10" id="content-box10">
            <div class="img"></div>
          </div>
          <div class="content-box11" id="content-box11">
            <div class="img"></div>
          </div>
          <div class="content-box12" id="content-box12">
            <div class="img"></div>
          </div>
        </div>
      </div>

      <div class="section" id="section8">
        <div class="container section8">
          <div class="content-box1">
            <div class="title-line">
              <div class="title">
                <img alt="xxx" src="../assets/imgs/902.png" style="width: 100%;" />
              </div>
              <div class="text">下载【上汽大众超级APP】进行绑定，享受更多上汽大众用户权益</div>
            </div>
          </div>
          <div class="content-box2">
            <img alt="xxx" src="../assets/imgs/9001.png" style="width: 100%;" />
          </div>
          <div class="content-box3">
            <img alt="xxx" src="../assets/imgs/9002.png" style="width: 100%;" />
          </div>
          <div class="content-box4">
            <img alt="xxx" src="../assets/imgs/9003.png" style="width: 100%;" />
          </div>
          <div class="content-box5">
            <div class="title pub-title2">上汽大众超级APP</div>
            <div class="text pub-text">
              旨在为用户提供互联互通的生活体验
              <br />以大众品牌统一用户账号
              <br />及品牌俱乐部统一积分体系为基础
              <br />集成五大核心功能的上汽大众首款全方位APP
            </div>
          </div>
          <div class="content-box6">
            <div class="line">
              <div class="con-img">
                <div class="img">
                  <img alt="xxx" src="../assets/imgs/9004.png" style="width: 100%;" />
                </div>
                <div class="pub-text">智慧车联</div>
              </div>
              <div class="con-img">
                <div class="img">
                  <img alt="xxx" src="../assets/imgs/9005.png" style="width: 100%;" />
                </div>
                <div class="pub-text">品牌资讯</div>
              </div>
              <div class="con-img">
                <div class="img">
                  <img alt="xxx" src="../assets/imgs/9006.png" style="width: 100%;" />
                </div>
                <div class="pub-text">会员俱乐部</div>
              </div>
              <div class="con-img">
                <div class="img">
                  <img alt="xxx" src="../assets/imgs/9007.png" style="width: 100%;" />
                </div>
                <div class="pub-text">售后服务</div>
              </div>
              <div class="con-img">
                <div class="img">
                  <img alt="xxx" src="../assets/imgs/9008.png" style="width: 100%;" />
                </div>
                <div class="pub-text">在线商城</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <canvas id="stars" class="stars"></canvas>
    </div>
    <MosMobile v-if="isPhone"></MosMobile>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "../components/mos/mos.js";
import { startRains } from "../components/mos/star.js";
import MosMobile from "./MosMobile";
export default {
  name: "Mos",
  components: {
    MosMobile
  },
  data() {
    return {
      isPhone: false,
      sectionIndex: 0, // 翻页的页签
      section0Play: false, // 首页视频是否播放
      canScroll: true // 是否可以滑动
    };
  },
  mounted: function() {
    // 判断是否手机
    this.getIsPhone();
    if (this.isPhone == false) {
      // 初始化设置section高度
      this.setSectionHeight();
      // 设置css
      this.setSectionCss();
      //其他浏览器直接绑定滚动事件
      if (getBrowserType() == "FF") {
        document.addEventListener("DOMMouseScroll", this.scrollFunc, false);
      } else {
        document.onmousewheel = this.scrollFunc;
      }
      // 监听键盘
      document.onkeydown = this.scrollKeyFunc;
      // 浏览器改变大小监听事件
      window.onresize = this.setSectionHeight;
      // 定时任务
      this.setSection7Time();
      // 背景
      startRains();
    }
  },
  methods: {
    // 初始化设置section高度
    setSectionHeight() {
      const h = getBrowserHight();
      const height = `${h}px`;
      document.getElementById("section0").style.height = height;
      document.getElementById("section1").style.height = height;
      document.getElementById("section2").style.height = height;
      document.getElementById("section3").style.height = height;
      document.getElementById("section4").style.height = height;
      document.getElementById("section5").style.height = height;
      document.getElementById("section6").style.height = height;
      document.getElementById("section7").style.height = height;
      document.getElementById("section8").style.height = height;
    },
    // 设置内部的css的样式
    setSectionCss() {},
    // 鼠标滚动事件
    scrollFunc(e) {
      e = e || window.event;
      if (e.wheelDelta) {
        //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) {
          //当滑轮向上滚动时
          this.changePage("up");
        }
        if (e.wheelDelta < 0) {
          //当滑轮向下滚动时
          this.changePage("down");
        }
      } else if (e.detail) {
        //Firefox滑轮事件
        if (e.detail > 0) {
          //当滑轮向上滚动时
          this.changePage("down");
        }
        if (e.detail < 0) {
          //当滑轮向下滚动时
          this.changePage("up");
        }
      }
      return false; // 加这行不然IE会重复下滑
    },
    // 键盘上下键
    scrollKeyFunc() {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if ((e && e.keyCode == 38) || (e && e.keyCode == 37)) {
        //上,左
        this.changePage("up");
      }
      if ((e && e.keyCode == 40) || (e && e.keyCode == 39)) {
        //下,右
        this.changePage("down");
      }
      return false; // 加这行不然IE会重复下滑
    },
    // 翻页事件
    changePage(t) {
      if (this.canScroll) {
        this.canScroll = false;
        setTimeout(() => {
          this.canScroll = true;
        }, 100);
        if (t == "down") {
          if (this.sectionIndex < 8) {
            this.sectionIndex++;
          }
          // 流星背景，只有下滑的时候才有
          startRains();
        } else if (t == "up") {
          if (this.sectionIndex > 0) {
            this.sectionIndex--;
          }
        }
        this.changePageImp(t);
      }
    },
    changePageImp(t) {
      if (this.canScroll) {
        this.canScroll = false;
        setTimeout(() => {
          this.canScroll = true;
        }, 100);
        if (t == "down") {
          if (this.sectionIndex < 8) {
            this.sectionIndex++;
          }
          // 流星背景，只有下滑的时候才有
          startRains();
        } else if (t == "up") {
          if (this.sectionIndex > 0) {
            this.sectionIndex--;
          }
        }
      }

      // 纠正sectionIndex
      if (this.sectionIndex < 0) {
        this.sectionIndex == 0;
      }
      if (this.sectionIndex > 8) {
        this.sectionIndex == 8;
      }
      // 距离上边的高度
      let height = 0;
      if (this.sectionIndex == 0) {
        height = 0;
      } else if (this.sectionIndex == 1) {
        height = getBrowserHight() * 1;
      } else if (this.sectionIndex == 2) {
        height = getBrowserHight() * 2;
      } else if (this.sectionIndex == 3) {
        height = getBrowserHight() * 3;
      } else if (this.sectionIndex == 4) {
        height = getBrowserHight() * 4;
      } else if (this.sectionIndex == 5) {
        height = getBrowserHight() * 5;
      } else if (this.sectionIndex == 6) {
        height = getBrowserHight() * 6;
      } else if (this.sectionIndex == 7) {
        height = getBrowserHight() * 7;
      } else if (this.sectionIndex == 8) {
        height = getBrowserHight() * 8;
      }
      // 滑动到位置
      const type = getBrowserType();
      if (type == "IE") {
        window.scrollTo(0, height);
      } else {
        window.scrollTo({
          top: height,
          behavior: "smooth"
        });
      }
    },
    // 改变section0是否播放视频
    changeSection0Play() {
      this.section0Play = !this.section0Play;
    },
    // section7定时任务
    setSection7Time() {
      let second1 = 0;
      let second2 = 0;
      setInterval(() => {
        second1++;
        second2++;
        if (second1 == 0) {
          document.getElementById("content-box2").style.opacity = 1;
          document.getElementById("content-box4").style.opacity = 1;
          document.getElementById("content-box6").style.opacity = 1;
          document.getElementById("content-box8").style.opacity = 1;
          document.getElementById("content-box10").style.opacity = 1;
          document.getElementById("content-box12").style.opacity = 1;
        } else if (second1 == 1) {
          document.getElementById("content-box2").style.opacity = 0.6;
          document.getElementById("content-box4").style.opacity = 0.6;
          document.getElementById("content-box6").style.opacity = 0.6;
          document.getElementById("content-box8").style.opacity = 0.6;
          document.getElementById("content-box10").style.opacity = 0.6;
          document.getElementById("content-box12").style.opacity = 0.6;
        } else if (second1 == 2) {
          document.getElementById("content-box2").style.opacity = 0.2;
          document.getElementById("content-box4").style.opacity = 0.2;
          document.getElementById("content-box6").style.opacity = 0.2;
          document.getElementById("content-box8").style.opacity = 0.2;
          document.getElementById("content-box10").style.opacity = 0.2;
          document.getElementById("content-box12").style.opacity = 0.2;
        } else if (second1 == 3) {
          document.getElementById("content-box2").style.opacity = 0;
          document.getElementById("content-box4").style.opacity = 0;
          document.getElementById("content-box6").style.opacity = 0;
          document.getElementById("content-box8").style.opacity = 0;
          document.getElementById("content-box10").style.opacity = 0;
          document.getElementById("content-box12").style.opacity = 0;
        } else if (second1 == 13) {
          document.getElementById("content-box2").style.opacity = 0.2;
          document.getElementById("content-box4").style.opacity = 0.2;
          document.getElementById("content-box6").style.opacity = 0.2;
          document.getElementById("content-box8").style.opacity = 0.2;
          document.getElementById("content-box10").style.opacity = 0.2;
          document.getElementById("content-box12").style.opacity = 0.2;
        } else if (second1 == 14) {
          document.getElementById("content-box2").style.opacity = 0.6;
          document.getElementById("content-box4").style.opacity = 0.6;
          document.getElementById("content-box6").style.opacity = 0.6;
          document.getElementById("content-box8").style.opacity = 0.6;
          document.getElementById("content-box10").style.opacity = 0.6;
          document.getElementById("content-box12").style.opacity = 0.6;
        } else if (second1 == 15) {
          document.getElementById("content-box2").style.opacity = 1;
          document.getElementById("content-box4").style.opacity = 1;
          document.getElementById("content-box6").style.opacity = 1;
          document.getElementById("content-box8").style.opacity = 1;
          document.getElementById("content-box10").style.opacity = 1;
          document.getElementById("content-box12").style.opacity = 1;
        } else if (second1 > 25) {
          second1 = 0;
        }

        if (second2 == 0) {
          document.getElementById("content-box3").style.opacity = 0;
          document.getElementById("content-box5").style.opacity = 0;
          document.getElementById("content-box7").style.opacity = 0;
          document.getElementById("content-box9").style.opacity = 0;
          document.getElementById("content-box11").style.opacity = 0;
        } else if (second2 == 1) {
          document.getElementById("content-box3").style.opacity = 0.4;
          document.getElementById("content-box5").style.opacity = 0.4;
          document.getElementById("content-box7").style.opacity = 0.4;
          document.getElementById("content-box9").style.opacity = 0.4;
          document.getElementById("content-box11").style.opacity = 0.4;
        } else if (second2 == 2) {
          document.getElementById("content-box3").style.opacity = 0.8;
          document.getElementById("content-box5").style.opacity = 0.8;
          document.getElementById("content-box7").style.opacity = 0.8;
          document.getElementById("content-box9").style.opacity = 0.8;
          document.getElementById("content-box11").style.opacity = 0.8;
        } else if (second2 == 3) {
          document.getElementById("content-box3").style.opacity = 1;
          document.getElementById("content-box5").style.opacity = 1;
          document.getElementById("content-box7").style.opacity = 1;
          document.getElementById("content-box9").style.opacity = 1;
          document.getElementById("content-box11").style.opacity = 1;
        } else if (second2 == 13) {
          document.getElementById("content-box3").style.opacity = 0.6;
          document.getElementById("content-box5").style.opacity = 0.6;
          document.getElementById("content-box7").style.opacity = 0.6;
          document.getElementById("content-box9").style.opacity = 0.6;
          document.getElementById("content-box11").style.opacity = 0.6;
        } else if (second2 == 14) {
          document.getElementById("content-box3").style.opacity = 0.2;
          document.getElementById("content-box5").style.opacity = 0.2;
          document.getElementById("content-box7").style.opacity = 0.2;
          document.getElementById("content-box9").style.opacity = 0.2;
          document.getElementById("content-box11").style.opacity = 0.2;
        } else if (second2 == 15) {
          document.getElementById("content-box3").style.opacity = 0;
          document.getElementById("content-box5").style.opacity = 0;
          document.getElementById("content-box7").style.opacity = 0;
          document.getElementById("content-box9").style.opacity = 0;
          document.getElementById("content-box11").style.opacity = 0;
        } else if (second2 > 25) {
          second2 = 0;
        }
      }, 300);
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/css/mos.css";
</style>
